
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.28 6h8l6 6v.069l-2 2.005V13h-5V8h-7v16h12v-3.5l2-2.006V24c0 1.1-.9 2-2 2H8.27c-1.1 0-1.99-.9-1.99-2l.01-16c0-1.1.89-2 1.99-2z","fill":"#252626"}}),_c('path',{attrs:{"d":"M17.216 21.917l-4.252-4.253 1.488-1.488 2.764 2.764 7.016-7.016 1.489 1.488-8.505 8.505z","fill":"#EEC148"}})])
          )
        }
      }
    